import { render } from "./DbsIndex.vue?vue&type=template&id=11be4ae0"
import script from "./DbsIndex.vue?vue&type=script&lang=js"
export * from "./DbsIndex.vue?vue&type=script&lang=js"
script.render = render

export default script